<template>
  <div class="container-fluid h-100">
    <!-- Imagen de fondo -->
    <div 
      :style="{ backgroundImage: 'url(' + image.url + ')' }" 
      class="content-login" 
      id="content1-login" 
      title="login motero - havoline moto club"
      alt="login motero - havoline moto club"
    >
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <!-- Texto que va sobre la imagen -->
        <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12 padding-t">
          <!-- Título -->
          <h1 class="title-login-motero">
            {{ image.description != null ? image.description : '' }}
          </h1>
          <!-- Subtítulo -->
          <h2 class="subtitle-login-motero">
            {{ image.subtitle != null ? image.subtitle : '' }}
          </h2>
          <h3 class="small-register">
            Si aún no tienes cuenta
          </h3><br>
          <!-- Botón 1 -->
          <button
            v-if="image.button_1 != null ? image.button_1 : ''"
            @click="irRedirection(image.redirection_button_1)"
            class="btn btn-danger font-none"
          >
            {{ image.button_1 != null ? image.button_1 : '' }}
          </button>

          <!-- <h1 class="club">INICIA SESIÓN CON HAVOLINE MOTOCLUB</h1>
          <p class="ingresa">
            Entre más códigos registres, más beneficios puedes redimir. <br>
          <small class="small-register">Si aún no tienes cuenta</small> <br/>
          <button class="btn btn-danger font-none" @click="irRegistro()">
            Regístrate
          </button>
          </p> -->
        </div>
        <div class=" col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
          <div
            class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
          >
            <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12">
              <label class="text-login">Inicia sesión para</label>
              <label class="text-login pb-2">registrar tus códigos</label>
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text color-input-fixed-icon">
                      <span class="fa-solid fa-user"></span>
                    </span>
                  </div>
                  <input 
                    type="text"
                    v-model="form.email"
                    class="form-control color-input-fixed-text"
                    placeholder="CORREO ELECTRÓNICO"
                    aria-label="Email"
                    :class="{ 'is-danger': errors.email }"
                  >
                </div>
                <span
                  v-if="errors.email"
                  class="text-danger float-left small error-danger"
                  >{{ errors.email }}</span
                >
              </div>
              <div class="form-group">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span class="input-group-text color-input-fixed-icon">
                      <span class="fa-solid fa-lock"></span>
                    </span>
                  </div>
                  <input
                    v-model="form.pass"
                    type="password"
                    ref="password"
                    class="form-control color-input-fixed-text"
                    placeholder="CONTRASEÑA"
                    aria-label="Password"
                    :class="{ 'is-danger': errors.pass }"
                    @keyup.enter="login()"
                  >
                  <div @click="showPass()" class="eye_pass">
                    <span id="pass" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger"
                  >{{ errors.pass }}</span
                >
              </div>
            </div>
            <div
              class="pb-3 col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12 mx-auto"
            >
              <a
                class="reset-password"
                data-toggle="modal"
                data-target="#exampleModal"
                >¿Olvidaste la contraseña?</a
              >
            </div>
            <div class="col-12 col-md-12 col-lg-3 col-xl-3 col-sm-12">
              <button
                @keyup.enter="login()"
                :disabled="disableLoading"
                type="button"
                @click="login()"
                class="btn btn-danger btn-md btn-block button-register"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>
                  Entrar
                </template>
              </button>
            </div>
          </div>

          <!-- REDES -->
          <div
            class="col-12 col-md-12 col-lg-9 col-xl-9 col-sm-12 mx-auto mt-4"
          >
            <p class="p-text1" style="text-align:center; font-size:15px">
              <strong>También inicia sesión con Google</strong>
            </p>

            <div class="row">
              <div class="col-12 col-md-12 col-lg-6 col-xl-6 col-sm-12 mx-auto">
                <button
                  :disabled="disableLoadingGoogle"
                  type="button"
                  @click="google()"
                  class="btn btn-light btn-sm btn-block btn-register"
                  id="btn-register-id"
                >
                  <span
                    v-if="disableLoadingGoogle"
                    class="spinner-border spinner-border-md"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <template v-else>
                    <img alt="Google" src="@/assets/icon/google-24px.png" />
                    <!-- <i style="color:black;"> Google </i> -->
                  </template>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de recuperar contraseña -->
    <div
      class="modal fade "
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5
              class="modal-title"
              id="exampleModalLabel"
              style="color: #6c757d"
            >
              Recuperar contraseña
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="input-group mb-3">
                <span class="fa fa-envelope-o icon iconreset"></span>
                <input
                  :class="{ 'is-danger': errorsEmail }"
                  v-model="email"
                  type="text"
                  class="form-control input-reset"
                  aria-label="email"
                  placeholder="Email *"
                  aria-describedby="basic-addon1"
                />
              </div>
              <span
                v-if="errorsEmail"
                class="text-danger float-left small error-danger"
                >{{ errorsEmail }}</span
              >
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary btn-sm"
              data-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              @click="resetPassword()"
              type="button"
              class="btn btn-danger btn-sm"
            >
              <span
                v-if="disableLoadingSend"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              <template v-else>Enviar</template>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from "../../config/auth";
import { ROL } from "../../config/utils";
import { ORIGIN } from "../../config/utils";
import axios from 'axios';
import $ from "jquery";

export default {
  name: "contentLanding",
  data() {
    return {
      data: {},
      sBrowser: null,
      sUsrAg: null,
      disableLoading: false,
      disableLoadingGoogle: false,
      disableLoadingSend: false,
      email: "",
      errorsEmail: false,
      newArr: [],
      errors: {
        email: false,
        pass: false
      },
      form: {
        email: "",
        pass: ""
      },
      imgsBackground: [],
      imgBack: [],
      image: {},
    };
  },
  watch: {
    "form.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.pass": function(n) {
      if (n) {
        this.errors.pass = false;
      } else {
        this.errors.pass = "La contraseña es requerida.";
      }
    },
    email: function(n) {
      if (!n) {
        this.errorsEmail = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errorsEmail = "El email es inválido.";
      } else {
        this.errorsEmail = false;
      }
    }
  },
  methods: {
    google() {
      this.$gapi.login().then(({ currentUser }) => {
        // console.log('currentUser: ', JSON.stringify(currentUser));
        var profileUser = currentUser.getBasicProfile();
        var profileU = Object.values(profileUser);
        // console.log('profileU: ', profileU);
        let id_token = currentUser.getAuthResponse().id_token;
        this.data = {
          name: profileU[2],
          last_name: profileU[3],
          email: profileU[5],
          token: id_token
        };
        this.disableLoadingGoogle = true;
        axios
          .post("api/login/google", this.data)
          .then(async res => {
            if (res.data.cod == 0) {
              login(res.data.data.access_token);
              var data1 = {
                email: res.data.data.email,
                validatePass: res.data.data.ch_pw,
                gender: res.data.data.gender_id
              };
              sessionStorage.setItem("infoUser", JSON.stringify(data1));
              let encodeUserRole = btoa("userRole");
              let encodeValueUserRole = btoa(res.data.data.roleId);
              sessionStorage.setItem(encodeUserRole, encodeValueUserRole);
              if(res.data.data.codResponse == 0){
                this.$router.push({ name: "registerGoogle" });
              } else {
                var flagData = await localStorage.getItem('flagUpdateData');
                if(flagData > 0){
                  this.$router.push({ name: "updateDataUser" });
                } else {
                  if (this.$route.params.option == "digitales") {
                    this.$router.push({ name: "catalogueEcommerce" });
                  } else {
                    this.redirection(res.data.data.roleId);
                  }
                }
              }
            }
            this.disableLoadingGoogle = false;
          })
          .catch(error => {
            this.$swal({
              icon: "info",
              title: "Oops...",
              text: error.response.data.message,
              confirmButtonText: 'OK',
              confirmButtonColor: "#dc3545",
            });
            this.disableLoadingGoogle = false;
          });
      });
    },
    // facebook() {
    //   var app = this;
    //   window.FB.login(
    //     response => {
    //       console.log("fb response", response);
    //       if (response.status === "connected") {
    //         console.log("Conexión exitosa");
    //         FB.api("/me", { fields: "last_name, name, email" }, function(
    //           resApi
    //         ) {
    //           console.log(JSON.stringify(resApi));
    //           var data = {
    //             name: resApi.name,
    //             lastName: resApi.last_name,
    //             email: resApi.email,
    //             token: response.authResponse.accessToken
    //           };
    //           axios
    //             .post("api/login/facebook", data)
    //             .then(resB => {
    //               if (resB.data.cod == 0) {
    //               }
    //             })
    //             .catch(error => {
    //               app.$swal({
    //                 icon: "error",
    //                 title: "Oops...",
    //                 text: error.response.data.message
    //               });
    //             });
    //         });
    //       } else if (response.status === "not_authorized") {
    //         app.$swal({
    //           icon: "error",
    //           title: "Oops...",
    //           text: "No fue autorizado por Facebook para realizar esta acción"
    //         });
    //         console.log("No fue autorizado por fdacebook");
    //       } else {
    //         console.log("Error al conectarse con facebook");
    //         app.$swal({
    //           icon: "error",
    //           title: "Oops...",
    //           text: "No fue autorizado por Facebook para realizar esta acción"
    //         });
    //       }
    //     },
    //     { scope: "public_profile,email" }
    //   );
    // },
    irRegistro() {
      this.$router.push({ name: "registerUser" });
    },
    login() {
      this.disableLoading = true;
      var app = this;
      if (this.validateForm()) {
        this.form.origin = ORIGIN.USER;
        axios
          .post("api/login", this.form)
          .then(async function(res) {
            if (
              res.data.access_token != "" &&
              res.data.access_token != undefined
            ) {
              login(res.data.access_token);
              var data = {
                email: app.form.email,
                validatePass: res.data.ch_pw,
                gender: res.data.gender_id
              };
              sessionStorage.setItem("infoUser", JSON.stringify(data));
              let encodeUserRole = btoa("userRole");
              let encodeValueUserRole = btoa(res.data.roleId);
              sessionStorage.setItem(encodeUserRole, encodeValueUserRole);
              var flagData = await localStorage.getItem('flagUpdateData');
              // console.log('flagData: ', flagData);
              if(flagData > 0){
                app.$router.push({ name: "updateDataUser" });
              } else {
                if (app.$route.params.option == "digitales") {
                  app.$router.push({ name: "catalogueEcommerce" });
                } else {
                  app.redirection(res.data.roleId);
                }
              }
            } else {
              app.$swal({
                icon: "error",
                title: "Oops...",
                html: res.data.messages,
                confirmButtonColor: "#dc3545"
              });
            }
            app.disableLoading = false;
          })
          .catch(function(err) {
            if (err.response.data.code){
              app.$swal({
                confirmButtonColor: "#dc3545",
                confirmButtonText: 'Ir',
                icon: "error",
                title: "Ingreso fallido",
                text: err.response.data.messages
              }).then(() => {
                  location.href = "/login/lubricador";
                }
              );
              app.disableLoading = false;
              this.$router.push({name: "loginLubricator"});
            }
            else{
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: "Credenciales incorrectas"
              });
              app.disableLoading = false;
            }
          });
      }
    },
    redirection(rolId) {
      console.log(rolId);
      console.log(ROL.COMMERCIALROLE);
      switch (rolId) {
        case ROL.COMMERCIALROLE:
          this.$router.push({ name: "comercialProfile" });
          break;
        case ROL.LUBRICATORROLE:
          this.$router.push({ name: "lubricatorProfile" });
          break;
        case ROL.COLJUEGOS:
          this.$router.push({ name: "coljuegosProfile" });
          break;
        default:
          this.$router.push({ name: "profileUser" });
          break;
      }
    },
    resetPassword() {
      var app = this;
      this.disableLoadingSend = true;
      var data = {
        email: this.email
      };
      if (this.validateReset()) {
        axios
          .post("api/password/create", data)
          .then(function(res) {
            if (res.data.ResponseCode == 0) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "success",
                title: "Muy bien",
                text: res.data.ResponseMessage
              });
            } else if (res.data.ResponseCode == 1) {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage
              });
            } else {
              app.$swal({
                confirmButtonColor: "#dc3545",
                icon: "error",
                title: "Oops...",
                text: "Error al recuperar contraseña"
              });
            }
            app.disableLoadingSend = false;
          })
          .catch(function(error) {
            console.log(error);
            app.disableLoadingSend = false;
          });
      }
    },
    irRegistrar() {
      this.$router.push({ name: "registerUser" });
    },
    validateForm() {
      if (!this.form.email) {
        this.errors.email = "El email es requerido.";
        this.disableLoading = false;
        return false;
      }
      if (!this.form.pass) {
        this.errors.pass = "La contraseña es requerida.";
        this.disableLoading = false;
        return false;
      }
      if (
        !this.errors.email &&
        !this.errors.pass &&
        !this.validEmail(this.errors.email)
      ) {
        return true;
      }
      this.disableLoading = false;
      return false;
    },
    validateReset() {
      if (!this.email) {
        this.errorsEmail = "El email es requerido.";
      }
      if (!this.errorsEmail && !this.validEmail(this.errorsEmail)) {
        return true;
      }
      this.disableLoading = false;
      return false;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    getImgsBackground(){
      let app = this;
      axios
      .get('api/file/imgsBackground')
      .then((response) => {
        if(response.data.cod == 0){
          app.imgsBackground = response.data.data;
          app.imgsBackground.forEach(element => {
            if(element.type_view == 10){
              app.imgBack.push(element);
              app.getImage();
            }
          });
        } else {
          app.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: response.data.ResponseMessage
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    },
    getImage(){
      const ancho = window.innerWidth;
      let newImage = null;
      // Buscar la imagen correspondiente al tamaño actual de la pantalla
      if(ancho <= 480) {
        newImage = this.imgBack.find(img => img.size === 7);
      } else if(ancho > 480 && ancho <= 780) {
        newImage = this.imgBack.find(img => img.size === 6);
      } else if(ancho > 780) {
        newImage = this.imgBack.find(img => img.size === 5);
      }
      // Actualizar la imagen de fondo solo si es diferente a la actual
      if(newImage && (!this.image || newImage.url !== this.image.url)) {
        this.image = newImage;
      }
    },
    irRedirection(url) {
      if (url != null && url != '') {
        var a = document.createElement('a');
        a.href=url;
        a.click();
      }
    },
    showPass(){
      let pass = this.$refs.password;
      if(pass.type == "password"){
        pass.type = "text";
        $('#pass').addClass('fa-eye');
        $('#pass').removeClass('fa-eye-slash');
      } else {
        pass.type = "password";
        $('#pass').addClass('fa-eye-slash');
        $('#pass').removeClass('fa-eye');
      }
    },
  },
  eforeDestroy() {
    // Eliminar el listener de resize antes de destruir el componente
    window.removeEventListener('resize', this.getImage);
  },
  mounted(){
    this.getImgsBackground();
    // Detectar cuando cambia el tamaño de la pantalla
    window.addEventListener('resize', this.getImage);
  },
};
</script>

<style scoped>
.content-login {
  padding-left: 5%;
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
}
.title-login-motero{
  font-family: "Gotham-UltraItalic", sans-serif;
  font-size: 60px;
  text-align: left !important;
  padding: 5px;
  width: 100%;
  color: white;
}
.subtitle-login-motero {
  font-family: "GothamBookItalic", sans-serif;
  font-size: 25px;
  text-align: left !important;
  padding: 5px;
  max-width: 100%;
}
.small-register {
  font-family: "GothamBoldItalic", sans-serif !important;
  font-size: 13px;
  float: left;
}
.btn-danger{
  float: left;
}
.font-none {
  font-family: "Arial", sans-serif;
}
.club {
  font-size: 60px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.ingresa {
  font-size: 25px;
  text-align: left;
  font-family: "GothamBookItalic", sans-serif;
}
.t-c {
  text-align: center;
}
label.text-login {
  color: #000;
  margin-bottom: 0rem;
  font-family: "GothamBoldItalic", sans-serif;
  font-size: 15px;
}
#content1-login {
  background-size: cover;
  /* background-image: url("../../assets/img/03.jpg"); */
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.color-login {
  background-color: #ffffff00 !important;
  border: solid 0px !important;
}
a.reset-password {
  cursor: pointer !important;
  color: white;
}
a.reset-password:hover {
  color: #b3b3b3 !important;
}
.color-input-fixed-text{
  background-color: #ffffff00 !important;
  color: #fff !important;
  height: 30px !important;
  font-size: 13px;
}
.color-input-fixed-icon{
  background-color: #ffffff00 !important;
  color: white;
  height: 30px !important;
}
.color-input-fixed-text::placeholder {
  color: white !important;
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0.375rem 3rem !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
}
.color-input-fixed-text{
  background-color: #ffffff00 !important;
  color: #000 !important;
  height: 30px !important;
  font-size: 13px;
}
.color-input-fixed-icon{
  background-color: #ffffff00 !important;
  color: white;
  height: 30px !important;
}
.color-input-fixed-text::placeholder {
  color: black !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.icon-disable {
  color: #676565 !important;
}
.input-code:disabled {
  opacity: 0 !important;
  border-color: #000000 !important;
}
.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}
.icon::before {
  position: absolute;
  top: 25%;
  left: 5%;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
  color: black;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .content-login {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content-login {
    height: 100%;
  }
  .padding-t {
    padding-top: 5%;
    padding-bottom: 8%;
  }
  .title-login-motero{
    font-family: "Gotham-UltraItalic", sans-serif;
    font-size: 45px;
    text-align: left !important;
    padding: 5px;
    width: 100%;
    color: white;
  }
  .subtitle-login-motero {
    font-family: "GothamBookItalic", sans-serif;
    font-size: 25px;
    text-align: left !important;
    padding: 5px;
    max-width: 100%;
  }
  .small-register {
    font-family: "GothamBoldItalic", sans-serif !important;
    font-size: 13px;
    float: inherit;
  }
  .btn-danger{
    float: inherit;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .content-login {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }
  .club {
    font-size: 40px;
    text-align: left;
  }
  .ingresa {
    font-size: 18px;
    text-align: left;
  }
  .margin-btn {
    margin-bottom: 35%;
  }
  .title-login-motero{
    font-family: "Gotham-UltraItalic", sans-serif;
    font-size: 35px;
    text-align: center !important;
    padding: 5px;
    width: 100%;
    color: white;
  }
  .subtitle-login-motero {
    font-family: "GothamBookItalic", sans-serif;
    font-size: 20px;
    text-align: center !important;
    padding: 5px;
    max-width: 100%;
  }
  .small-register {
    font-family: "GothamBoldItalic", sans-serif !important;
    font-size: 13px;
    float: inherit;
  }
  .btn-danger{
    float: inherit;
  }
}
</style>
